import {EChannelType} from 'src/constants';
import {ELicensePeriod} from 'src/containers/Licenses/definitions';
import {
  ESmsTrafficType,
  EViberTrafficType,
  EWhatsappTrafficType,
} from 'src/containers/TariffsCatalog';

export default {
  allTariffs: {
    addTariff: 'Add tariff',
    tariffOption: 'Tariff {{channelType}}',
    connectedTariffs: 'Active tariffs',
    availableTariffs: 'Available tariffs',
  },
  availableTariffs: {
    title: 'Available channels and tariffs',
    channels: 'Channels available for connection',
    tariffs: 'Channel tariffs',
    noTariffsChannel:
      'Fill out the channel registration application <0>here</0> and receive tariff terms from a manager',
  },
  selectTariff: 'Choose tariff',
  tariffCard: {
    tariff: 'Tariff:',
    channel: 'Channel:',
    activeFrom: 'Activation date:',
    willChange: 'Will change {{date}}',
    willChangeTariff: 'Switch to another available tariff plan is scheduled {{date}}',
    linkedSubjects: 'linked channels',
    linkedTariff: 'available tariff {{name}}',
    pricing: 'What does the tariff consist of?',
    history: 'Change history',
    invisible: 'Tariff is hidden from the customer',
    connect: 'Connect',
    options: 'The tariff includes:',
  },
  actions: {
    showSettings: 'View settings',
    showChanges: 'View changes',
    cancelChanges: 'Cancel changes',
    deleteTariff: 'Delete tariff',
    changeDate: 'Change date',
    changeTariff: 'Change tariff',
    revealTariff: 'Show tariff to customer',
  },
  deleteModal: {
    title: 'Delete tariff?',
    subtitle: 'The tariff will be removed from the list of available tariffs',
  },
  hideModal: {
    title: 'Hide tariff?',
    subtitle:
      "Cannot delete the tariff from available ones while there are <0>active tariffs linked to it</0>. Hide the tariff from the Customer's Personal Account?",
    submitButton: 'Hide tariff',
    successNotification: 'Available tariff {{name}} has been hidden from the Personal Account.',
  },
  cancelChangesModal: {
    title: 'Cancel scheduled changes?',
    subtitle:
      'Changes previously scheduled for this tariff will not take effect on the specified date',
    submitButton: 'Cancel changes',
  },
  linkedSubjectsModal: {
    title: 'Channels using the tariff:',
  },
  changePlannedDateModal: {
    title: 'Adjust tariff change date',
    setNewDate: 'Set a new tariff change date',
    plannedDate: 'Scheduled tariff change date',
    newDate: 'New tariff change date',
    submitButton: 'Adjust',
  },
  editTariffModal: {
    plannedTitle: 'Scheduled tariff change',
    activeTitle: 'Scheduled tariff change',
    settingsTitle: 'Parameters of tariff {{name}}',
    modifyTitle: 'Modify tariff {{name}}',
    title: 'Change tariff {{name}}',
    plannedInfo: 'Scheduled change will take effect {{date}}',
    baseTariff: 'Base tariff',
    coefficients: 'Base tariff',
    coefficientsHint: 'To change the tariff cost for the customer, change the applied coefficients',
    modifyHint:
      'To change the tariff cost for the customer, change the coefficients of the base tariff',
    coefficient: 'Coefficient',
    baseLicensePrice: 'Base license cost,  {{currency}}',
    licensePrice: 'Final license cost,  {{currency}}',
    baseConnectionFee: 'Base connection cost,  {{currency}}',
    connectionFee: 'Final connection cost,  {{currency}}',
    baseAmau: 'Base AMAU cost,  {{currency}}',
    amau: 'Final AMAU cost,  {{currency}}',
    createButton: 'Create tariff',
    planButton: 'Schedule changes',
  },
  confirmEditModal: {
    title: 'Schedule tariff change?',
    hint: 'The available tariff will change on the 1st of the next month',
    linkedTariffHint:
      'The available tariff will change from the 1st of the next month, <0>linked active tariffs</0> will change upon the next license renewal',
    submitButton: 'Schedule',
  },
  createTariffModal: {
    title: 'Create available tariff {{channelType}} for the customer',
    parameters: 'Tariff parameters',
    period: 'Tariff validity period',
    selectBaseTariff: 'Select base tariff',
    mauCount: 'Number of MAUs per period',
    monthLicensePrice: 'License cost,  {{currency}} per month',
    licensePrice: 'License cost,  {{currency}}',
    connectionFee: 'Connection cost,  {{currency}}',
    amauPrice: 'AMAU cost,  {{currency}}',
    modifyTariffButton: 'Modify tariff',
    submitButton: 'Create tariff',
  },
  editConnectedTariffModal: {
    title: 'Change active tariff {{channelType}} for the customer',
    planButton: 'Schedule',
    period: 'Tariff validity period',
    parameters: 'Current tariff parameters',
    createTariffButton: 'Create tariff',
    nextTariff: 'Future tariff',
    willChangeAt: 'The tariff will change on the next license renewal date – {{date}}',
    selectNextTariff: 'Select an available tariff to switch to',
    onlyTargetTariffHint:
      'The customer has only one available tariff, which is already in use. Add a tariff to available ones to switch the license to it.',
  },
  historyModal: {
    title: 'Tariff change history',
    changeDate: '{{date}} Tariff changed',
    connectDate: '{{date}} Tariff activated',
  },
  licensePeriod: {
    [ELicensePeriod.MONTH]: 'Month',
    [ELicensePeriod.YEAR]: 'Year',
  },
  pricesIsWithoutVat: '*Price is indicated without VAT',
  successNotifications: {
    createTariff: 'Available tariff {{name}} has been added to the customer.',
    changeTariff: 'Available tariff {{name}} changed.',
    changeConnectedTariff: 'Active tariff {{name}} changed.',
    addTariff: 'Available tariff {{name}} added to the customer.',
    cancelChanges: 'Scheduled changes for tariff {{name}} have been cancelled.',
    hideTariff: 'Available tariff {{name}} has been hidden from the Personal Account.',
    deleteTariff: 'Available tariff {{name}} has been deleted.',
  },
  tariffSelect: {
    label: 'Tariff for channel',
    hint: 'Select from your available tariffs. <0>Your available tariffs</0> <1></1>',
    placeholder: 'Select tariff',
  },
  pricing: {
    vatHint:
      'The cost of messages is deducted from the balance in the currency of your Personal Account. Prices are indicated without VAT',
    more: 'Details',
  },
  priceByPeriod: '{{price}}\u00a0{{currency}}\u00a0/\u00a0{{period}}',
  smsPricing: {
    licensePrice: 'Channel License payment:',
    licensePriceHint: '{{licensePrice}} {{currency}} per month for all sender names',
    detailPricing: 'Service payment:',
    detailPricingHint: '<0>Monthly fee and sent SMS according to the Price List</0>',
    pricingHint:
      '—\nPrices are displayed excluding VAT. VAT is applied in accordance with applicable laws.',
    messagePriceLink: 'Message pricing',

    modalTitle: 'SMS tariff according to price list',
    pricingType: 'Tariff type:',
    recurrentAmount: 'Subscription fee for the sender name:\n<0>{{price}}\u00a0{{currency}}</0>',
    templateAmount: 'Operator template price:\n<0>{{price}}\u00a0{{currency}} / 1 template</0>',
    feePricing: 'Message cost:',
    messagePrice: 'Message price:\n<0>{{price}}\u00a0{{currency}}</0>',
    messagesLimit: 'Number of messages',
    upperLimit: 'Above {{limit}}',
    mauTitle: {
      [ESmsTrafficType.ADV]: 'Advertising messages price:',
      [ESmsTrafficType.SERVICE]: 'Service messages price:',
      [ESmsTrafficType.AUTH]: 'Authorization messages price:',
      [ESmsTrafficType.INFO]: 'Informational messages price:',
      [ESmsTrafficType.MARKETING]: 'Marketing messages price:',
    },
    packageLimit: 'SMS package per unique subscriber',
    packagePrice: 'Package price excl. VAT, {{currency}}',
    packageLimits: {
      exact: '{{count}} SMS per subscriber',
      range: '{{from}} – {{to}} SMS per subscriber',
      from: 'From {{from}} SMS per subscriber',
    },
    perMessage: '{{price}} / per SMS',
    traffic: {
      [ESmsTrafficType.SERVICE]: 'Cost of service message, {{currency}}',
      [ESmsTrafficType.AUTH]: 'Cost of authentication message, {{currency}}',
      [ESmsTrafficType.MARKETING]: 'Cost of marketing message, {{currency}}',
      [ESmsTrafficType.ADV]: 'Cost of advertising message, {{currency}}',
      [ESmsTrafficType.INFO]: 'Cost of promotional message, {{currency}}',
    },
  },
  viberPricing: {
    licensePrice: 'Channel License payment: ',
    licensePriceHint: '{{licensePrice}} {{currency}} per month for all sender names',
    detailPricing: 'Service payment:',
    detailPricingHint: '<0>Paid Viber messages according to the Price List</0>',
    packagePrice: 'Minimum payment for messages per month {{packagePrice}}\u00a0{{currency}}',
    pricingHint:
      '—\nPrices are displayed excluding VAT. VAT is applied in accordance with applicable laws.',
    packagePriceShort: 'Minimum payment for messages ',
    packagePriceShortHint:
      "Fixed monthly fee, even if your messages cost less. This is the messenger's requirement for using an official sender name. If you send more in a month — you pay only for the actual volume.",
    modalTitle: 'Viber message cost',
    pricing: 'Message cost, prices are in {{currency}}',
    country: 'Country',
    traffic: {
      [EViberTrafficType.SERVICE]: 'Service traffic',
      [EViberTrafficType.MARKETING]: 'Promotional traffic',
    },
    trafficPricing: 'Traffic cost',
  },
  whatsappPricing: {
    licensePrice: 'Channel License payment: ',
    licensePriceHint:
      '{{licensePrice}} {{currency}} per {{period}} for {{mauCount}} active customers (MAU) per month.\n' +
      '{{amauPrice}} {{currency}} for each customer beyond {{mauCount}} MAU.',
    detailPricing: 'Service payment:',
    detailPricingHint:
      '<0>Paid WhatsApp messages according to the Price List</0><br/>' +
      '<1>Which WhatsApp messages are considered free?</1><2></2>',
    connectionFee: 'Channel connection',
    connectionFeeHint: '{{connectionFee}} {{currency}}  - charged once.',
    pricingHint:
      '—\nPrices are displayed excluding VAT. VAT is applied in accordance with applicable laws.' +
      '\n*MAU is a unique phone number that sent or received a message from you within a month',

    modalTitle: 'WhatsApp message cost',
    pricing: 'Message cost, prices are in {{currency}}',
    country: 'Country',
    traffic: {
      [EWhatsappTrafficType.AUTHENTICATION]: 'Authentication',
      [EWhatsappTrafficType.MARKETING]: 'Marketing \nCloud API',
      [EWhatsappTrafficType.MARKETING_LITE]: 'Marketing \nMM API',
      [EWhatsappTrafficType.SERVICE]: 'Service (non-template)',
      [EWhatsappTrafficType.UTILITY]: 'Utility',
    },
    serviceHint: 'Service messages are charged from the 1,001st delivery each month',
    trafficPricing: 'Traffic cost',
    mauHint:
      'MAU (Monthly Active Users) — unique phone numbers that exchanged messages with you over the month',
    amauPrice: 'AMAU price: {{amauPrice}}{{currency}} without VAT',
    mauCount: '{{mauCount}} MAU* <0></0>',
  },
  licensePricing: {
    licensePrice: 'Channel License payment:',
    licensePriceHint: '{{licensePrice}} {{currency}} per month per sender',
    pricingHint:
      '—\nPrices are displayed excluding VAT. VAT is applied in accordance with applicable laws.',
  },
  channelHint: {
    [EChannelType.SMS]:
      'Classic SMS broadcasts with maximum reach. Direct carrier connections, delivery tracking, and detailed statistics.',
    [EChannelType.MAX]:
      'Personalized MAX messenger broadcasts. Promotions, transactional notifications, and customer updates.',
    [EChannelType.MAX_BOT]:
      'MAX chatbot for conversational automation. Handles questions, runs scenarios, and manages inquiries 24/7 — no human agent needed.',
    [EChannelType.VIBER]:
      'Viber broadcasts and two-way conversations. Rich media support — images, buttons, and files.',
    [EChannelType.WHATSAPP]:
      "WhatsApp broadcasts and two-way conversations. Template notifications, interactive buttons, media files, and attachments. Click tracking for buttons. The world's most popular messenger.",
  },
  tariffOptions: {
    [EChannelType.SMS]: ['Cascades', 'API Integration'],
    [EChannelType.MAX]: [
      'Incoming and outgoing messages',
      'Dialogues',
      'Scenarios',
      'Cascades',
      'API Integration',
    ],
    [EChannelType.MAX_BOT]: [
      'Incoming and outgoing messages',
      'Dialogues',
      'Scenarios',
      'Cascades',
      'API Integration',
    ],
    [EChannelType.VIBER]: ['Cascades', 'API Integration'],
    [EChannelType.WHATSAPP]: ['Coexistence', 'Scenarios', 'API Integration'],
    [EChannelType.TELEGRAM]: [
      'Incoming and outgoing messages',
      'Dialogues',
      'Scenarios',
      'Cascades',
      'API Integration',
    ],
  },
  acceptTariffs: {
    banner:
      'Familiarize yourself with the pricing and click "{{buttonName}}". The pricing becomes active once accepted.',
    acceptTariffs: 'Accept pricing',
    fine: 'Fine!',
  },
  acceptTariffsModal: {
    title: 'Accept your pricing',
    description:
      'Familiarize yourself with the pricing and click "{{buttonName}}". Once the pricing is accepted, the channels are available for registration',
  },
};
